<template>
    <main class="skiplink-target main" id="content" tabindex="-1">
        <div class="container">
            <header class="row">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content content--header">
                        <section class="content-header">
                            <h1>{{labels.vraagscherm.kop}}</h1>
                            <p>{{labels.vraagscherm.stapIndicator}}</p>
                        </section>
                    </div>
                </div>
            </header>
            <article>
                <div class="row">
                    <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                        <div class="content-background">
                            <div class="content">
                                <div v-if="toonVraag" v-bind:class="[inputClass, {'input--invalid': v$.vraag.$error}]">
                                    <div class="input__error" v-if="!v$.vraag.required">{{labels.errors.verplichtVeldVraag}}</div>
                                    <div class="input__error" v-if="v$.vraag.maxLength === false">
                                        {{labels.errors.maxLength}}
                                    </div>
                                    <label class="input__label"
                                           for="textarea_voorbeeld">{{labels.vraagscherm.subkop}}</label>
                                    <textarea id="textarea_voorbeeld" v-model="vraag" @blur="() => { this.v$.vraag.$touch() }"
                                              class="input__control input__control--l input__control--text"></textarea>
                                </div>
                                <div v-if="!toonVraag">
                                    <label class="input__label" v-html="labels.vraagscherm.perpost"></label>
                                </div>
                                <p>
                                    <button v-if="toonVraag" v-bind:class="[btnClass, {'btn--disabled ': v$.vraag.$invalid}]"
                                            @click="gaVerder">{{labels.algemeen.button}}
                                    </button>
                                    <button v-if="!toonVraag" v-bind:class="[btnClass]"
                                            @click="gaVerder">{{labels.algemeen.button}}
                                    </button>
                                    {{labels.algemeen.of}}
                                    <router-link :to="{name: 'reden-contact'}">{{labels.algemeen.labelVorige}}
                                    </router-link>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </main>

</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    import { useVuelidate } from '@vuelidate/core'
    import {required, maxLength} from '@vuelidate/validators'

    export default {
        name: "vraag",
        setup () {
            return {
            v$: useVuelidate()
            }
        },
        data() {
            return {
                inputClass: 'input',
                btnClass: 'btn btn--primary'
            }
        },
        computed: {
            ...mapGetters(['labels']),
            ...mapState(['form']),
            vraag: {
                set(vraag) {
                    this.v$.vraag.$touch();
                    this.$store.commit('setVraag', vraag)
                },
                get() {
                    return this.form.vraag
                }
            },
            toonVraag() {
                if (this.$store.state.form.redenContact === "bericht-personenregister"){
                    return false;
                }
                return true;
            }
        },
        created() {
            this.$trackPageView('Vraag');              
        },
        methods: {
            gaVerder() {
                this.v$.vraag.$touch();
                if (this.toonVraag) {
                    if (this.v$.vraag.$pending || this.v$.vraag.$error) return;
                }
                else{this.$store.commit('setVraag', "")}
                this.$router.push({name: 'gegevens-invoeren'});
            }
        },
        validations: {
            vraag: {
                required,
                maxLength: maxLength(3000)
            }
        }
    }
</script>

<style scoped>

</style>